import Spinner from 'Components/Spinner/Spinner';
import { scaleTime } from 'd3-scale';
import React, { useLayoutEffect, useRef, useState } from 'react';
import { Chart, ChartCanvas } from 'react-stockcharts';
import { AreaSeries } from 'react-stockcharts/lib/series';
import { SpinnerStyled } from '../style';
import {
  AreaChartWrapper,
  ChartStyled,
  LeftSideLine,
  XAxsisStyled,
  YAxsisStyled,
} from './AreaChart.style';
import {
  ChartTitle,
  ChartTitleMoreInfo,
  ChartTitleText,
} from './GainersAndLosers.style';

const AreaChart = ({ data }) => {
  const xAccessor = (d) => d?.time;
  const [chartSize, setChartSize] = useState({ width: 0, height: 0 });
  const ChartRef = useRef(null);

  useLayoutEffect(() => {
    if (ChartRef?.current) {
      const onResize = () => {
        const height = 150 || (ChartRef?.current?.offsetHeight * 65) / 100;
        const width = ChartRef?.current?.offsetWidth;
        console.log(width, 'width width width width');
        setChartSize({ width, height });
      };
      window.addEventListener('resize', onResize);
      onResize();

      return () => {
        window.removeEventListener('resize', onResize);
      };
    }
  }, [ChartRef?.current]);

  const yGrid = {
    innerTickSize: 1 * chartSize.width,
    tickStrokeOpacity: 0.8,
    tickStrokeWidth: 1,
  };

  const xGrid = {
    innerTickSize: -1 * chartSize.height,
    tickStrokeOpacity: 0.8,
    tickStrokeWidth: 1,
  };

  return (
    <AreaChartWrapper>
      <ChartTitle>
        <ChartTitleText>
          CURRENT MARKET
          <ChartTitleMoreInfo>&#105;</ChartTitleMoreInfo>
        </ChartTitleText>
      </ChartTitle>
      {!data?.length ? (
        <SpinnerStyled>
          <Spinner />
        </SpinnerStyled>
      ) : (
        ''
      )}
      <ChartStyled ref={ChartRef}>
        {data.length && chartSize.width ? (
          <ChartCanvas
            ratio={1}
            width={chartSize.width - 10}
            height={chartSize.height}
            data={data}
            type="svg"
            seriesName="MSFT"
            xScale={scaleTime()}
            xAccessor={xAccessor}
            xExtents={[data[0].time, data[data.length - 1].time]}
            zoomEvent={false}
            zoomEnabled={false}
            clamp={false}
            disableInteraction
            margin={{
              left: 2,
              right: 0,
              top: 0,
              bottom: 0,
            }}
          >
            <Chart
              padding={{
                bottom: 2,
                left: 50,
                right: 8,
                top: 0,
              }}
              id={1}
              height={chartSize.height - 20}
              yExtents={(d) => d.close}
            >
              <AreaSeries yAccessor={(d) => d.close} />
              <YAxsisStyled
                tickStroke="#FFFFFF"
                zoomEnabled={false}
                zoomEvent={false}
                axisAt="right"
                orient="right"
                {...yGrid}
              />
              <XAxsisStyled
                stroke="#FFFFFF"
                tickStroke="#FFFFFF"
                axisAt="bottom"
                orient="bottom"
                ticks={5}
                {...xGrid}
              />
              <defs>
                <linearGradient
                  id="e"
                  x1="0"
                  y1="0"
                  x2="100%"
                  y2="15"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="rgba(0, 0, 0, 1)" offset="0" />
                  <stop stopColor="rgba(255, 255, 255, 1)" offset="0.5" />
                  <stop stopColor="rgba(34, 38, 86, 1)" offset="1" />
                </linearGradient>
              </defs>
              <LeftSideLine
                x1="-2"
                x2="-2"
                y2="25px"
                y1={chartSize.height - 19}
              />
            </Chart>
          </ChartCanvas>
        ) : (
          ''
        )}
      </ChartStyled>
    </AreaChartWrapper>
  );
};

export default AreaChart;
